import { KeyboardArrowDown } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import type { FC } from "react";

import { RidesKanbanSortDropdownStyled } from "./rides.panels.styled";
import { useRidesKanbanSortDropdown } from "./use-rides-kanban-sort-dropdown";

export const RidesKanbanSortDropdown: FC = () => {
  const {
    title,
    selectedLabel,
    menuOptions,
    menuAnchor,
    isMenuOpen,
    buttonId,
    menuId,
    menuSlotProps,
    openMenuHandler,
    closeMenuHandler,
  } = useRidesKanbanSortDropdown();

  return (
    <RidesKanbanSortDropdownStyled>
      <button
        type="button"
        id={buttonId}
        className="kanban_sort_button"
        aria-haspopup="menu"
        aria-expanded={isMenuOpen}
        aria-controls={isMenuOpen ? menuId : undefined}
        onClick={openMenuHandler}
        data-e2e="rides-kanban-sort-button"
      >
        <span className="kanban_sort_title">{title}</span>
        <span className="kanban_sort_value">{selectedLabel}</span>
        <KeyboardArrowDown className="kanban_sort_arrow" />
      </button>

      <Menu
        id={menuId}
        anchorEl={menuAnchor}
        open={isMenuOpen}
        onClose={closeMenuHandler}
        slotProps={menuSlotProps}
      >
        {menuOptions.map(option => (
          <MenuItem
            key={option.sort}
            role="menuitemradio"
            selected={option.isSelected}
            onClick={option.selectHandler}
            data-e2e={`rides-kanban-sort-option-${option.sort}`}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </RidesKanbanSortDropdownStyled>
  );
};
